import { MapMarkerClusterer } from './map-marker-clusterer.model';

export class UnassignedDeliveryMapMarkerCluster extends MapMarkerClusterer {}
